/* eslint-disable no-unused-vars */
/*
  Display List of notifications in top right side of the page, reuses many components.
  One of used components is dashboard notification which for now is used to display:
  - NOTIFICATION_SHARES_TRADED
 */
import { mapActions, mapState } from 'vuex';
import notificationItemSimple from '@/components/notification-items/notification-item-simple/notification-item-simple.vue';
import notificationItemTradeConfirmed from '@/components/notification-items/notification-item-trade-confirmed/notification-item-trade-confirmed.vue';
import notificationItemDashboard from '@/components/notification-items/notifcation-item-dashboard/notification-item-dashboard.vue';
import { NOTIFICATION_SHARES_TRADED_CLOSE_DELAY, NOTIFICATION_TRADE_CONFIRMED, NOTIFICATION_MATCHED, NOTIFICATION_SIMPLE, NOTIFICATION_SHARES_TRADED, NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY, NOTIFICATION_TRADER_LEVEL_CHANGED } from '@/services/notifications/proxy';

const ROUTE_PORTFOLIO = 'portfolio';

export default {
  components: {
    notificationItemDashboard,
    notificationItemSimple,
    notificationItemTradeConfirmed,
  },
  data() {
    return {
      NOTIFICATION_SHARES_TRADED_CLOSE_DELAY,
      NOTIFICATION_TRADE_CONFIRMED_CLOSE_DELAY,
      activeNotification: null,
      currentRoute: this.$router.currentRoute,
    };
  },
  watch: {
    notificationList(value) {
      this.activeNotification = value[value.length - 1];
    },
    $route(to, from) {
      this.currentRoute = to;
      if (from.name !== to.name) {
        this.clear();
      }
    },
  },
  computed: {
    ...mapState('notifications', ['notificationList']),
    mockNotifications() {
      return [
        {
          index: 1,
          method: 'asd',
          type: NOTIFICATION_SIMPLE,
          data: {
            closeTimeout: 3500,
            icon: 'pending',
            text: 'You will be notified when processing is complete.',
            title: 'Order Received'
          },
        },
        {
          index: 2,
          method: 'asd',
          type: NOTIFICATION_TRADE_CONFIRMED,
          data: {"ContractId":18492,"Name":"test1","MarketId":7458,"MarketName":"Placeholder Test Market Multi Outcome","MarketUrl":"Placeholder-Test-Market-Multi-Outcome","MarketType":3,"ImageName":"default.jpg","TotalProfit":0,"TotalFees":0,"ShowRisk":false,"TotalRiskChange":0,"TotalCost":0,"Offer":{"OfferId":285028,"ContractId":18492,"Quantity":1,"RemainingQuantity":1,"DateCreated":"2023-05-17T11:27:42.14","TradeType":1,"PricePerShare":0.99},"History":[],"TimeStamp":"1684322862.08828","Guid":"460c5426-b273-461b-a067-3a7256202edc","UpdateType":"tradeConfirmed_data"},
        },
        {
          index: 3,
          method: 'asd',
          type: NOTIFICATION_SIMPLE,
          data: {
            closeTimeout: 3500,
            title: 'Error Occurred',
            icon: 'cancel',
            text: 'Order Received. You will be notified when processing is complete.',
          },
        },
        {
          index: 4,
          method: 'asd',
          type: NOTIFICATION_TRADE_CONFIRMED,
          data: {"ContractId":18492,"Name":"test1","MarketId":7458,"MarketName":"Placeholder Test Market Multi Outcome","MarketUrl":"Placeholder-Test-Market-Multi-Outcome","MarketType":3,"ImageName":"default.jpg","TotalProfit":0,"TotalFees":0,"ShowRisk":false,"TotalRiskChange":0,"TotalCost":0,"Offer":{"OfferId":285028,"ContractId":18492,"Quantity":1,"RemainingQuantity":0,"DateCreated":"2023-05-17T11:27:42.14","TradeType":1,"PricePerShare":0.99},"History":[{}],"TimeStamp":"1684322862.08828","Guid":"460c5426-b273-461b-a067-3a7256202edc","UpdateType":"tradeConfirmed_data"},
        },
      ];
    },
    notificationsToDisplay() {
      // TODO
      // return this.mockNotifications
      return this.notificationList.filter(this.isNotificationDisplayable);
    },
    shouldDisplayNotifications() {
      return this.notificationsToDisplay.length > 0;
    },
  },
  methods: {
    ...mapActions('notifications', ['clear']),
    onClose() {
      // TODO
      this.clear();
    },
    isNotificationDisplayable(notification) {
      return this.shouldDisplayNotificationSimple(notification) ||
          this.shouldDisplayNotificationTradeConfirmed(notification) ||
          this.shouldDisplayDashboardNotification(notification);
    },
    shouldDisplayNotificationSimple(notification) {
      return notification.type === NOTIFICATION_SIMPLE;
    },
    shouldDisplayNotificationTradeConfirmed(notification) {
      // TODO
      // return true;
      const displayRouteNames = [
        'market-details',
        'market-details-sushi',
        'market-detail-contracts',
        'market-detail-rules',
        'market-detail-charts',
        'market-detail-history',
        'market-detail-discussion',
        'market-details-legacy',
      ]
      if (displayRouteNames.includes(this.currentRoute.name)) {
        return (
          notification.type === NOTIFICATION_TRADE_CONFIRMED &&
          notification.data.MarketId.toString() === this.currentRoute.params.marketId.toString()
        );
      } else if (this.currentRoute.name === ROUTE_PORTFOLIO) {
        return notification.type === NOTIFICATION_TRADE_CONFIRMED;
      }
      return false;
    },
    shouldDisplayDashboardNotification(notification) {
      const types = [
        NOTIFICATION_SHARES_TRADED,
        NOTIFICATION_TRADER_LEVEL_CHANGED,
      ];
      return types.includes(notification.type);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notification-items/notification-items.js